import CardElementTextFormat from './CardElementTextFormat';

export default CardElementTextFormat;
